module.exports = __webpack_public_path__ + "static/media/share.e8ed07ca.svg";